import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import util from 'util/Util.js';
import formatTemplate from 'properties/style/image_background.ejs';
import { pickerCfg } from 'pickerCfg.js';

class StyleImageBackgroundView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #imageBackgroundText' : 'updateColorAttributesWithValidation',
            'change #imageBackgroundColor' : 'updateColorAttributesWithValidation',            
            'change input[type=color]': 'updateColorAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        return this;
    }

    render() {
        super.render();
        
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        
        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();
        return this;
    }

}

export default StyleImageBackgroundView;
